export default {
      id: "i-sber-logo-usage",
      viewBox: "0 0 121 21",
      url: __webpack_public_path__ + "img/sprite.svg#i-sber-logo",
      toString: function () {
        return this.url;
      }
    }